var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isView),expression:"isView"}],staticClass:"Svg",on:{"click":_vm.playVideo}},[_c('img',{attrs:{"src":_vm.img}})])
}
var staticRenderFns = []

export { render, staticRenderFns }